import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDLv3sqfSmZdEYcljON2aBtHdIHqqG2Q5U",
  authDomain: "diabetes-tipo-2.firebaseapp.com",
  databaseURL: 'https://diabetes-tipo-2-default-rtdb.firebaseio.com/',
  projectId: "diabetes-tipo-2",
  storageBucket: "diabetes-tipo-2.appspot.com",
  messagingSenderId: "942350810372",
  appId: "1:942350810372:web:c8cb182546e66dd7fb6451",
  measurementId: "G-KXS8L2980L"
};
// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
